"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextWrappedFetchSym = exports.Fetch = void 0;
exports.Fetch = Symbol('Fetch');
exports.ContextWrappedFetchSym = Symbol('ContextWrappedFetch');
//# sourceMappingURL=fetch.js.map